import script from "./SharedLogsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./SharedLogsTable.vue?vue&type=script&setup=true&lang=js"

import "./SharedLogsTable.vue?vue&type=style&index=0&id=21d34303&scoped=true&lang=css"

import exportComponent from "/home/runner/work/bot-v2/bot-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21d34303"]])

export default __exports__